import Component from 'component';
import _debounce from 'lodash/debounce';
import { BREAKPOINT } from '../constants';

class FeaturedReviewsSlider extends Component {
  constructor(el) {
    super(el);
    this.initSlick();
  }

  setupDefaults() {
    this.dom = {
      $slider: this.$el.find('.reviews-list__content'),
      $dotsContainer: this.$el.find('.featured-review__dots'),
      $slides: this.$el.find('.reviews-list__review')
    };
  }

  addListeners() {
    $(window).on('resize', _debounce(::this.initSlick, 100));
  }

  initSlick() {
    const _that = this;
    if (
      window.matchMedia(`screen and (min-width: ${BREAKPOINT.tablet}px)`)
        .matches
    ) {
      if (this.dom.$slider.hasClass('slick-initialized')) {
        this.dom.$slider.slick('unslick');
      }
    } else {
      if (!this.dom.$slider.hasClass('slick-initialized')) {
        _that.dom.$slider.slick({
          arrows: false,
          infinite: true,
          dots: true,
          appendDots: _that.dom.$dotsContainer,
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst: true,
          adaptiveHeight: true,
          responsive: [
            {
              breakpoint: BREAKPOINT.desktop,
              settings: 'unslick'
            }
          ]
        });
      }
    }
  }
}

export default FeaturedReviewsSlider;



// WEBPACK FOOTER //
// ./src/tc/js/components/FeaturedReviewsSlider.js